import styled from 'styled-components'
import { COLORS } from 'utils'

import { IconStyles } from '../types'

export const ErrorBoundariesIcon = styled.div<IconStyles>`
  width: ${({ size }) => size ? `${size}px;` : '24px;'}
  height: auto;
  margin-top: ${({ marginTop }) => marginTop || '0'};
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
  margin-left: ${({ marginLeft }) => marginLeft || '0'};
  margin-right: ${({ marginRight }) => marginRight || '0'};
  cursor: ${({ cursor }) => cursor};

  path {
    fill: ${({ colorIcon }) => colorIcon || COLORS.black};
  }
`
